/*
 * @Author: kongxiangyu
 * @Date: 2022-11-24 11:44:54
 * @LastEditTime: 2022-11-24 16:09:47
 * @email: kongxiangyu@cd.baidu.com
 * @Description: EventBus
 */

import Vue from 'vue';
export default new Vue();
